module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('myP')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right",
    class: {
      'de22': _vm.isDe || _vm.isFr, 'cz22': _vm.isCz
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/back.png")
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('home')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-wrap"
  }, [_c('div', {
    staticClass: "item post"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Postcode')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.zipcode),
      expression: "profile.zipcode"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Mobile')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.mobile),
      expression: "profile.mobile"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Telephone')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.telephone),
      expression: "profile.telephone"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.email),
      expression: "profile.email"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item email"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Bio')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.motto),
      expression: "profile.motto"
    }],
    staticClass: "name",
    domProps: {
      "value": (_vm.profile.motto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.motto = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25b02f3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-templates/recent-updates.vue
// module id = 1436
// module chunks = 7